<template>
  <span class="card-category" :class="colored && categorySlug">
    {{ category }}
  </span>
</template>

<script>
// Utilities
import { formatTitle } from 'Utils'

export default {
  name: 'CardCategory',

  props: {
    category: {
      type: String,
      required: true,
    },

    colored: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    categorySlug() {
      const categorySlug = formatTitle(this.category.split(' / ').join('-').split('/').join('-'))
      return categorySlug
    },
  },
}
</script>

<style scoped>
.card-category {
  font-size: 8px;
  line-height: 12px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #fff;
  padding: 1px 6px;
  border-radius: 2px;
  background-color: var(--c-secondary-500);
  box-shadow: 0 0 10px -4px var(--rgba-default);
  text-transform: uppercase;
}

.card-category.estrategia,
.card-category.strategy {
  background: var(--c-orange-800);
}

.card-category.atraccion-traccion,
.card-category.attraction-traction {
  background: var(--c-pink-500);
}

.card-category.tecnologia,
.card-category.technology {
  background: var(--c-magenta-700);
}

.card-category.conversion {
  background: var(--c-yellow-600);
}

.card-category.fidelizacion,
.card-category.loyalty {
  background: var(--c-blue-300);
}

.card-category.cierre,
.card-category.closing {
  background: var(--c-aquamarine-600);
}

.card-category.contenidos,
.card-category.contents {
  background: var(--c-secondary-800);
}
</style>
